import { slices } from "@/constants/sliceNames";
import { createAsyncThunk } from "@reduxjs/toolkit";

import axios from "../../../axios/defaultAxios";
import { errorMessage } from "../../actions/messages.actions";
import { resetRunExecution } from "../../slices/run-execution/runExecution-slice";

import { EXECUTION_STATUS } from "./util";

const ENDPOINT = "/appexecutions/v2";

/******* Run execution ********/

export const requestRunExecution = createAsyncThunk(
  `${slices.runExecution}/requestRunExecution`,
  async ({ payload, resolve }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(`${ENDPOINT}/${payload.execution_type}`, payload);
      if (response.status === 200 || response.status === 201) {
        const appexecID = response.data.data.id;
        const appexec = response.data.data;
        resolve && resolve(appexecID, response.status, appexec);
        return response.data.data;
      }
      throw new Error(response.data?.message);
    } catch (error) {
      dispatch(errorMessage(error.response?.data?.error || error.message));
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);

export const requestRunExecutionStatus = {
  [requestRunExecution.fulfilled]: (state, action) => {
    state.executionStatus = EXECUTION_STATUS.IN_PROGRESS;
  },
  [requestRunExecution.pending]: (state, action) => {
    state.isCanceled = false;
    state.isDone = false;
    state.executionStatus = EXECUTION_STATUS.START;
    state.executionProgress = 0;
  },
  [requestRunExecution.rejected]: (state, action) => {
    state.executionStatus = null;
  },
};

/******* Stop execution ********/

export const requestStopExecution = createAsyncThunk(
  `${slices.runExecution}/requestStopExecution`,
  async ({ executionId, resolve, reject }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(`${ENDPOINT}/stop/${executionId}`);
      if (response.status === 200 || response.status === 201) {
        dispatch(resetRunExecution());
        // notification is handled by the ajaxHandler reducer
        // dispatch(successMessage(response.data.message));
        return response?.data?.data;
      }
      throw new Error(response.message);
    } catch (error) {
      reject && reject();
      dispatch(errorMessage(error.response?.data?.error || error.message));
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);

export const requestStopExecutionStatus = {
  [requestStopExecution.fulfilled]: (state, action) => {},
  [requestStopExecution.pending]: (state, action) => {},
  [requestStopExecution.rejected]: (state, action) => {},
};

/****** Run dataset analysis ******/

export const requestRunDatasetAnalysis = createAsyncThunk(
  `${slices.runExecution}/requestRunDatasetAnalysis`,
  async ({ datasetId, resolve, reject }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(`/datasets/analysis/${datasetId}`);
      if (response.status === 200 || response.status === 201) {
        resolve && resolve(response.data.data.execution_id, response.status);
        return response.data.data.execution_id;
      }
      throw new Error(response.data?.error);
    } catch (error) {
      reject && reject(error.response?.data?.error);
      dispatch(errorMessage(error.response?.data?.error || error.message));
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);

export const requestRunDatasetAnalysisStatus = {
  [requestRunDatasetAnalysis.fulfilled]: (state, action) => {
    state.executionStatus = EXECUTION_STATUS.IN_PROGRESS;
  },
  [requestRunDatasetAnalysis.pending]: (state, action) => {
    state.isCanceled = false;
    state.isDone = false;
    state.executionStatus = EXECUTION_STATUS.START;
    state.executionProgress = 0;
  },
  [requestRunDatasetAnalysis.rejected]: (state, action) => {
    state.executionStatus = null;
  },
};
